import styled from 'styled-components';

export const CircularProgressStyles = styled.div<{ size: number }>`
  position: relative;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;

  svg {
    filter: drop-shadow(0 8px 16px rgba(0, 0, 0, 0.5));
    width: 100%;
    height: 100%;
  }

  @media (max-width: 480px) {
    width: ${({ size }) => Math.min(size * 0.7, 200)}px;
    height: ${({ size }) => Math.min(size * 0.7, 200)}px;
  }

  @media (max-width: 360px) {
    width: ${({ size }) => Math.min(size * 0.6, 170)}px;
    height: ${({ size }) => Math.min(size * 0.6, 170)}px;
  }
`;

export const ProgressTextStyles = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    font-weight: 600;
    font-style: normal;
    font-size: 54px;
    line-height: 100%;
    letter-spacing: 0;
    text-align: center;
    color: #6632cc;

    @media (max-width: 480px) {
      font-size: 38px;
    }

    @media (max-width: 360px) {
      font-size: 32px;
    }
  }
`;
